export default __webpack_public_path__ + "static/og-imageMap-c0994ba8ea97fe58b21821540d164782.jpg";